/* Virelle interactive sections.
   Every behavior here is enhancement. With JS disabled the sections are
   complete and readable: all tab panels are visible, the FAQ is native
   <details>, and the cart form still submits its preselected variant.
   Written to tolerate multiple instances of a section on one page, and to
   re-initialise after a Shopify theme-editor section render. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ------------------------------------------------ text size ---------- */
  function initTextSize(root) {
    var group = root.querySelector('[data-vr-textsize]');
    if (!group || group.dataset.vrReady) return;
    group.dataset.vrReady = '1';
    var buttons = group.querySelectorAll('button[data-size]');

    function apply(size, persist) {
      if (size === 'md') {
        document.documentElement.removeAttribute('data-vr-ts');
      } else {
        document.documentElement.setAttribute('data-vr-ts', size);
      }
      each(document.querySelectorAll('[data-vr-textsize] button[data-size]'), function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.size === size));
      });
      if (persist) {
        try { localStorage.setItem('virelle-textsize', size); } catch (e) {}
      }
    }

    each(buttons, function (b) {
      b.addEventListener('click', function () { apply(b.dataset.size, true); });
    });

    try {
      var saved = localStorage.getItem('virelle-textsize');
      if (saved) apply(saved, false);
    } catch (e) {}
  }

  /* ---------------------------------------------------- tabs ----------- */
  function initTabs(root) {
    each(root.querySelectorAll('[role="tablist"]'), function (list) {
      if (list.dataset.vrReady) return;
      list.dataset.vrReady = '1';
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));

      function select(tab, focus) {
        each(tabs, function (t) {
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }

      each(tabs, function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          select(tabs[(i + dir + tabs.length) % tabs.length], true);
        });
      });

      /* JS is on, so collapse to the selected panel */
      var selected = list.querySelector('[aria-selected="true"]') || tabs[0];
      if (selected) select(selected, false);
    });
  }

  /* ---------------------------------------------------- quiz ----------- */
  function initQuiz(root) {
    each(root.querySelectorAll('[data-vr-quiz]'), function (quiz) {
      if (quiz.dataset.vrReady) return;
      quiz.dataset.vrReady = '1';

      var questions = Array.prototype.slice.call(quiz.querySelectorAll('.vr-quiz-q'));
      var bar = quiz.querySelector('[data-vr-quiz-bar]');
      var real = quiz.querySelector('[data-vr-verdict="real"]');
      var fake = quiz.querySelector('[data-vr-verdict="fake"]');
      var current = 0;
      var sawFake = false;

      function paint(focusResult) {
        var done = current >= questions.length;
        each(questions, function (q, i) { q.hidden = i !== current; });
        if (real) real.hidden = !(done && !sawFake);
        if (fake) fake.hidden = !(done && sawFake);
        if (bar) bar.style.width = (done ? 100 : (current / questions.length) * 100 + 8) + '%';
        if (done && focusResult) {
          var panel = sawFake ? fake : real;
          var h = panel && panel.querySelector('h3');
          if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
        }
      }

      each(quiz.querySelectorAll('.vr-quiz-opt'), function (opt) {
        opt.addEventListener('click', function () {
          if (opt.dataset.verdict === 'fake') sawFake = true;
          current += 1;
          paint(true);
        });
      });

      each(quiz.querySelectorAll('[data-vr-quiz-restart]'), function (btn) {
        btn.addEventListener('click', function () {
          current = 0;
          sawFake = false;
          paint(false);
          var legend = questions[0] && questions[0].querySelector('legend');
          if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus(); }
        });
      });

      paint(false);
    });
  }

  /* ---------------------------------------------- calculator ----------- */
  function initCalc(root) {
    each(root.querySelectorAll('[data-vr-calc]'), function (calc) {
      if (calc.dataset.vrReady) return;
      calc.dataset.vrReady = '1';

      var tiers;
      try { tiers = JSON.parse(calc.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
      if (!tiers.length) return;

      var freeFrom = parseInt(calc.getAttribute('data-free-from'), 10);
      var monthsPer = parseFloat(calc.getAttribute('data-months-per')) || 2;
      var moneyFormat = calc.getAttribute('data-money') || '${{amount}}';

      var idx = tiers.reduce(function (best, t, i) {
        return t.selected ? i : best;
      }, Math.min(2, tiers.length - 1));

      var elN = calc.querySelector('[data-vr-n]');
      var elUnit = calc.querySelector('[data-vr-unit]');
      var elPrice = calc.querySelector('[data-vr-price]');
      var elPer = calc.querySelector('[data-vr-per]');
      var elMonths = calc.querySelector('[data-vr-months]');
      var elShip = calc.querySelector('[data-vr-ship]');
      var elId = calc.querySelector('[data-vr-variant-id]');
      var elCta = calc.querySelector('[data-vr-cta]');
      var minus = calc.querySelector('[data-vr-minus]');
      var plus = calc.querySelector('[data-vr-plus]');

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, v)
                          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
      }

      function paint() {
        var t = tiers[idx];
        if (elN) elN.textContent = t.bars;
        if (elUnit) elUnit.textContent = t.bars === 1 ? ' bar' : ' bars';
        if (elPrice) elPrice.textContent = money(t.price);
        if (elPer) elPer.textContent = money(Math.round(t.price / t.bars));
        if (elMonths) {
          var m = t.bars * monthsPer;
          elMonths.textContent = 'About ' + (m % 1 === 0 ? m : m.toFixed(1)) + ' months';
        }
        if (elShip) {
          var free = !isNaN(freeFrom) && t.bars >= freeFrom;
          elShip.textContent = free ? 'Free' : 'Calculated at checkout';
          elShip.classList.toggle('vr-is-free', free);
        }
        if (elId) elId.value = t.id;
        if (elCta) {
          elCta.disabled = !t.available;
          elCta.textContent = t.available ? elCta.getAttribute('data-label') : 'Sold out';
        }
        if (minus) minus.disabled = idx === 0;
        if (plus) plus.disabled = idx === tiers.length - 1;
      }

      if (minus) minus.addEventListener('click', function () { if (idx > 0) { idx -= 1; paint(); } });
      if (plus) plus.addEventListener('click', function () { if (idx < tiers.length - 1) { idx += 1; paint(); } });
      paint();
    });
  }

  /* ------------------------------------------- one video at a time ----- */
  function initVideos(root) {
    each(root.querySelectorAll('video'), function (v) {
      if (v.dataset.vrReady) return;
      v.dataset.vrReady = '1';
      v.addEventListener('play', function () {
        each(document.querySelectorAll('.vr video'), function (other) {
          if (other !== v) other.pause();
        });
      });
    });
  }

  /* -------------------------------------------------- reveals ---------- */
  function initReveal(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.vr-reveal'));
    if (!items.length) return;

    /* No observer, or motion is unwanted: leave everything visible. Nothing is
       hidden until we have a live observer to un-hide it again. */
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    each(root.querySelectorAll('[data-vr-stagger]'), function (group) {
      each(group.querySelectorAll('.vr-reveal'), function (el, i) {
        el.style.setProperty('--vr-d', Math.min(i * 120, 360) + 'ms');
      });
    });

    var io = new IntersectionObserver(function (entries) {
      each(entries, function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vr-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    function disarm(el) { el.classList.remove('vr-armed'); el.classList.add('vr-in'); }

    each(items, function (el) {
      /* Anything already on screen was never going to animate in — show it now
         rather than hiding it and waiting for a scroll that may never come. */
      if (el.getBoundingClientRect().top < window.innerHeight) { disarm(el); return; }
      el.classList.add('vr-armed');
      io.observe(el);           /* re-observing is harmless, so no one-shot guard:
                                   a section re-render must be able to re-arm. */
    });

    /* Failsafe: if anything is still armed and unrevealed once the page has
       settled, show it. Better a missed animation than hidden content. */
    function sweep() {
      each(items, function (el) {
        if (el.classList.contains('vr-armed') &&
            !el.classList.contains('vr-in') &&
            el.getBoundingClientRect().top < window.innerHeight) {
          disarm(el);
        }
      });
    }
    window.addEventListener('load', sweep, { once: true });
    setTimeout(sweep, 1200);
    setTimeout(sweep, 3000);

    /* Belt and braces: if the observer misbehaves — a stale one after a
       section re-render, a page opened in a background tab, a restore from
       bfcache — scrolling still reveals whatever has come into view. Throttled
       on a timestamp rather than requestAnimationFrame, because rAF is paused
       in hidden tabs, which is precisely when this fallback has to work. */
    var last = 0;
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last < 100) return;
      last = now;
      sweep();
    }, { passive: true });

    /* A page loaded in a background tab gets its observers throttled; sweep
       once it is actually looked at. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sweep();
    });
    window.addEventListener('pageshow', sweep);
  }

  /* ---------------------------------------------------- boot ----------- */
  function init(root) {
    root = root || document;
    initTextSize(root);
    initTabs(root);
    initQuiz(root);
    initCalc(root);
    initVideos(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Shopify theme editor: re-init a section after it re-renders. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
}());
